import {LayoutType} from '@wandb/weave/common/types/media';
import {ButtonSize, ButtonSizes} from '@wandb/weave/components/Button/types';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {IconName, IconNames} from '@wandb/weave/components/Icon/types';
// @todo: Migrate to 'Button' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {
  ToggleButtonGroup,
  ToggleOption,
} from '@wandb/weave/components/ToggleButtonGroup';
import React, {useCallback} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports

const BUTTON_VALUE_TO_LAYOUT: {[key: string]: LayoutType} = {
  Overlay: 'ALL_STACKED',
  Split: 'MASKS_NEXT_TO_IMAGE',
  Spread: 'ALL_SPLIT',
};
const BUTTON_VALUE_TO_ICON: {[key: string]: IconName} = {
  Overlay: IconNames.VersionsLayers,
  Split: IconNames.Split,
  Spread: IconNames.LayoutGrid,
};
const LAYOUT_TOGGLE_OPTIONS: ToggleOption[] = Object.entries(
  BUTTON_VALUE_TO_ICON
).map(([key, icon]) => ({
  value: key,
  icon,
}));

export const MaskControlsLayout = ({
  mediaKey,
  maskLayout,
  onChangeMaskLayout,
  size = ButtonSizes.Small,
}: {
  mediaKey: string;
  maskLayout: LayoutType;
  onChangeMaskLayout: (mediaKey: string, layoutType: LayoutType) => void;
  size?: ButtonSize;
}) => {
  const selectedLayout =
    Object.entries(BUTTON_VALUE_TO_LAYOUT).find(
      ([_, value]) => value === maskLayout
    )?.[0] ?? 'Overlay';

  const onToggleSelection = useCallback(
    (value: string) => {
      const layoutType = BUTTON_VALUE_TO_LAYOUT[value];
      if (layoutType) {
        onChangeMaskLayout(mediaKey, layoutType as LayoutType);
      }
    },
    [mediaKey, onChangeMaskLayout]
  );

  return (
    <ToggleButtonGroup
      className="rounded-lg"
      options={LAYOUT_TOGGLE_OPTIONS}
      value={selectedLayout}
      size={size}
      onValueChange={onToggleSelection}
    />
  );
};
